import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";
interface UsePagePageQueryParamsArgs {
    isInEditMode: boolean;
    canEdit: boolean;
    onEditModeChange: (isInEditMode: boolean) => void;
}
export interface PageEditModeQueryParams {
    editMode: boolean;
    [key: string]: unknown;
}

export const usePageEditModeQueryParams = ({
    isInEditMode,
    canEdit,
    onEditModeChange,
}: UsePagePageQueryParamsArgs) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    useEffect(() => {
        const { editMode = false, ...otherParams } =
            RouteUtils.queryStringToObject<PageEditModeQueryParams>(search);
        if (editMode && canEdit) {
            if (!isInEditMode) {
                onEditModeChange(!!editMode);
            }
            replace(
                RouteUtils.appendQueryParams(pathname, {
                    ...otherParams,
                })
            );
        }
    }, [canEdit, isInEditMode, onEditModeChange, pathname, replace, search]);
};
